import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/workingChief/workingChiefData.json";

export default function WorkingChief() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Работа с главными врачами кожно-венерологических учреждений
      </h1>

      <Accordion data={data} />
    </section>
  );
}
